(() => {
  'use strict';

  const state = {
    lockets: new Map(),
    chainVariantId: null,
    chainQty: 0,
    charms: new Map(),
    selectionCounter: 0,
  };

  const PRICES = window.__cbPrices || { locket: 29.99, charm: 9.99, chain: 6.99 };
  const fmt$ = window.__cbFmt || (n => '$' + n.toFixed(2));
  const MIN_CHARMS = 1;

  // Buy 1 get 2 free : dans chaque groupe de 3, le 1er est payant,
  // les 2 suivants gratuits. Dès le 2e charm, 1 FREE apparaît.
  // Test charms A/B (oct. 2026) : en groupe B, pas d'offre, prix par charm lu sur la carte
  const TEST_B = window.__cbTestGroup === 'B';
  function charmPrice(variantId) {
    if (!TEST_B) return PRICES.charm;
    const card = document.querySelector(`.cb-card--charm[data-variant-id="${variantId}"]`);
    return parseFloat(card?.dataset.priceB) || PRICES.charm;
  }
  function charmCompare(variantId) {
    const card = document.querySelector(`.cb-card--charm[data-variant-id="${variantId}"]`);
    return parseFloat(card?.dataset.compareB) || PRICES.charm;
  }

  function computeBogo(total) {
    if (TEST_B) return { free: 0, paid: total };
    const paid = Math.ceil(total / 3);
    return { free: total - paid, paid };
  }

  function totalCharmsSelected() {
    let t = 0;
    for (const { qty } of state.charms.values()) t += qty;
    return t;
  }

  function totalLocketsSelected() {
    let t = 0;
    for (const qty of state.lockets.values()) t += qty;
    return t;
  }

  // Handles spécifiques
  const SILVER_LOCKET_HANDLE = 'emerald-locket-silver';
  // Lien changé le 06/10/2026 (teardrop-locket-1 → teardrop-locket) : on accepte les deux
  const TEARDROP_LOCKET_HANDLES = ['teardrop-locket', 'teardrop-locket-1']; // chaîne fine 1 clasp au lieu de thick

  // Compte les lockets par handle selon un prédicat
  function countLockets(pred) {
    let t = 0;
    for (const [variantId, qty] of state.lockets.entries()) {
      const card = document.querySelector(`.cb-card--locket[data-variant-id="${variantId}"]`);
      if (card && pred(card.dataset.handle)) t += qty;
    }
    return t;
  }

  // La chaîne extra est OR → ne compte que les lockets or (exclut l'argent)
  function totalGoldLocketsSelected() {
    return countLockets(h => h !== SILVER_LOCKET_HANDLE);
  }
  function totalSilverLocketsSelected() {
    return countLockets(h => h === SILVER_LOCKET_HANDLE);
  }
  // Chaîne incluse THICK or : lockets or SAUF teardrop (qui a une chaîne fine)
  function totalGoldThickLocketsSelected() {
    return countLockets(h => h !== SILVER_LOCKET_HANDLE && !TEARDROP_LOCKET_HANDLES.includes(h));
  }
  function totalTeardropLocketsSelected() {
    return countLockets(h => TEARDROP_LOCKET_HANDLES.includes(h));
  }

  // Rappel visuel de la chaîne fine incluse (gratuite), couleur assortie au locket.
  // Purement informatif : pas un produit, jamais envoyé au panier.
  function renderIncludedChain() {
    const wrap = document.getElementById('cb-included-chain');
    if (!wrap) return;
    const topLine = document.querySelector('.cb-chain-included');
    const goldThick = totalGoldThickLocketsSelected();
    const teardrop = totalTeardropLocketsSelected();
    const silver = totalSilverLocketsSelected();

    // Le bloc chaîne incluse porte désormais le message → on masque la ligne texte
    if (topLine) topLine.hidden = true;
    wrap.hidden = false;

    // Placeholder grisé tant qu'aucun locket n'est sélectionné
    if (goldThick === 0 && teardrop === 0 && silver === 0) {
      wrap.innerHTML = `
        <div class="cb-included-item cb-included-item--placeholder">
          <img class="cb-included-item__img" src="${wrap.dataset.goldImg}" alt="Included chain">
          <div class="cb-included-item__info">
            <span class="cb-included-item__label">Matching chain included</span>
            <span class="cb-included-item__sub">A matching chain is included free with every locket.</span>
          </div>
        </div>`;
      return;
    }

    function itemHtml(img, title, sub, qty, alt) {
      return `
        <div class="cb-included-item" data-full-img="${img}">
          <img class="cb-included-item__img" src="${img}" alt="${alt}">
          <div class="cb-included-item__info">
            <span class="cb-included-item__label">${title} ×${qty}</span>
            <span class="cb-included-item__sub">${sub}</span>
            <span class="cb-included-item__free">FREE — included</span>
          </div>
        </div>`;
    }
    let html = '';
    if (goldThick > 0) html += itemHtml(wrap.dataset.goldImg, 'Gold thick chain', '18" (45cm) - 2 clasps (same as picture 1)', goldThick, 'Included gold thick chain');
    if (teardrop > 0)  html += itemHtml(wrap.dataset.teardropImg, 'Gold thin chain', '18" (45cm) - 1 clasp (only for teardrop locket)', teardrop, 'Included gold thin chain');
    if (silver > 0)    html += itemHtml(wrap.dataset.silverImg, 'Silver thick chain', '18" (45cm) - 2 clasps (same as picture 1)', silver, 'Included silver thick chain');
    wrap.innerHTML = html;
    wrap.hidden = false;
  }

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  // ── Gallery carousel dots (mobile) ───────────────────────────────────────
  function initGallery() {
    const track = document.getElementById('cb-gallery-track');
    const dots = $$('.cb-gallery__dot');
    if (!track || !dots.length) return;

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index);
        const slideWidth = track.offsetWidth;
        track.scrollTo({ left: slideWidth * idx, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', () => {
      const idx = Math.round(track.scrollLeft / track.offsetWidth);
      dots.forEach((d, i) => d.classList.toggle('cb-gallery__dot--active', i === idx));
    }, { passive: true });
  }

  // ── Lockets ───────────────────────────────────────────────────────────────
  function initLockets() {
    $$('.cb-card--locket').forEach(card => {
      const variantId = card.dataset.variantId;
      const minus = $('.cb-qty__btn--minus', card);
      const plus = $('.cb-qty__btn--plus', card);
      const qtyEl = $('.cb-qty__value', card);

      function setLocketQty(next) {
        if (next === 0) {
          state.lockets.delete(variantId);
          minus.disabled = true;
          card.classList.remove('cb-card--selected');
        } else {
          state.lockets.set(variantId, next);
          minus.disabled = false;
          card.classList.add('cb-card--selected');
          hideError('cb-locket-error');
        }
        qtyEl.textContent = next;
        updateUI();
      }

      // Clic sur la carte (image) → toggle 0/1
      card.addEventListener('click', (e) => {
        if (e.target.closest('.cb-card__qty')) return;
        const current = state.lockets.get(variantId) || 0;
        setLocketQty(current === 0 ? 1 : 0);
      });

      plus.addEventListener('click', () => {
        setLocketQty((state.lockets.get(variantId) || 0) + 1);
      });

      minus.addEventListener('click', () => {
        const current = state.lockets.get(variantId) || 0;
        if (current <= 0) return;
        setLocketQty(current - 1);
      });
    });
  }

  // ── Chain — carte cliquable identique aux lockets ────────────────────────
  function initChain() {
    const card = document.querySelector('.cb-card--chain');
    if (!card) return;
    const variantId = card.dataset.variantId;
    const minus = $('.cb-qty__btn--minus', card);
    const plus  = $('.cb-qty__btn--plus', card);
    const qtyEl = $('.cb-qty__value', card);

    function setChainQty(next) {
      // Plafonné au nombre de lockets OR sélectionnés (la chaîne extra est gold)
      const max = totalGoldLocketsSelected();
      next = Math.max(0, Math.min(next, max));

      if (next === 0) {
        state.chainVariantId = null;
        state.chainQty = 0;
        minus.disabled = true;
        card.classList.remove('cb-card--selected');
      } else {
        state.chainVariantId = variantId || null;
        state.chainQty = next;
        minus.disabled = false;
        card.classList.add('cb-card--selected');
      }
      qtyEl.textContent = next;
      updateUI();
    }

    // Clic n'importe où dans la section (titre, texte, carte, espace vide) → ouvre le popup.
    // Les boutons + / − sont exclus pour gérer la quantité normalement.
    const section = card.closest('.cb-section--chain') || card;
    section.addEventListener('click', (e) => {
      if (e.target.closest('.cb-card__qty')) return;
      if (typeof window.__cbOpenImg === 'function') window.__cbOpenImg(card.dataset.fullImg, card.dataset.fullImg2);
    });
    plus.addEventListener('click',  () => setChainQty(state.chainQty + 1));
    minus.addEventListener('click', () => setChainQty(state.chainQty - 1));
  }

  // ── Charms ────────────────────────────────────────────────────────────────
  function initCharms() {
    $$('.cb-card--charm').forEach(card => {
      const variantId = card.dataset.variantId;
      const minus = $('.cb-qty__btn--minus', card);
      const plus = $('.cb-qty__btn--plus', card);
      const qtyEl = $('.cb-qty__value', card);

      function setCharmQty(next) {
        if (next === 0) {
          state.charms.delete(variantId);
          minus.disabled = true;
          card.classList.remove('cb-card--selected');
        } else {
          state.selectionCounter += 1;
          state.charms.set(variantId, { qty: next, selectionOrder: state.selectionCounter });
          minus.disabled = false;
          card.classList.add('cb-card--selected');
          hideError('cb-charms-error');
        }
        qtyEl.textContent = next;
        updateUI();
      }

      // Clic sur la carte (image) → toggle 0/1
      card.addEventListener('click', (e) => {
        if (e.target.closest('.cb-card__qty')) return;
        const current = state.charms.get(variantId)?.qty || 0;
        setCharmQty(current === 0 ? 1 : 0);
      });

      plus.addEventListener('click', () => {
        setCharmQty((state.charms.get(variantId)?.qty || 0) + 1);
      });

      minus.addEventListener('click', () => {
        const current = state.charms.get(variantId)?.qty || 0;
        if (current <= 0) return;
        setCharmQty(current - 1);
      });
    });
  }

  // ── BOGO progress bar (mise à jour des 2 barres simultanément) ───────────
  // ── Bar animation engine ──────────────────────────────────────────────────
  const _barAnims = {};
  function _stopBar(id) {
    if (_barAnims[id]) { cancelAnimationFrame(_barAnims[id]); delete _barAnims[id]; }
  }
  function _pulseBar(el, id, center, amp, speed) {
    let t = 0;
    const tick = () => {
      t += speed;
      el.style.width = Math.max(0, Math.min(100, center + Math.sin(t) * amp)) + '%';
      _barAnims[id] = requestAnimationFrame(tick);
    };
    tick();
  }
  function _setBar(el, id, pct, settle) {
    _stopBar(id);
    el.style.transition = 'width 0.35s ease';
    el.style.width = pct + '%';
    if (settle !== undefined) {
      setTimeout(() => {
        el.style.transition = 'width 0.7s ease';
        el.style.width = settle + '%';
      }, 500);
    }
  }

  function updateBogoProgress(total) {
    if (TEST_B) return;
    const { free } = computeBogo(total);

    // Cycle de 3 : 1 payé + 2 offerts. posInCycle : 1=payé, 2=1er free, 0=cycle complet
    const posInCycle = total % 3;

    // Floor % augmente à chaque palier — la barre ne se vide jamais
    const floor = free === 0 ? 0 : Math.min(50 + (free - 2) * 6, 80);

    let msg;
    if (total === 0)            msg = 'Select at least 1 charm to start';
    else if (posInCycle === 1)  msg = 'Add 1 more charm — get it FREE 🎁';
    else if (posInCycle === 2)  msg = `🎉 ${free} FREE unlocked! Add 1 more — also FREE`;
    else                        msg = `🎉 ${free} FREE charms unlocked! Keep going — buy 1, get 2 free`;

    [['cb-bogo-fill', 'cb-bogo-text'], ['cb-bogo-fill-2', 'cb-bogo-text-2']].forEach(([fillId, textId]) => {
      const fillEl = document.getElementById(fillId);
      const textEl = document.getElementById(textId);
      if (!fillEl) return;

      fillEl.classList.remove('cb-bogo-progress__fill--idle', 'cb-bogo-progress__fill--excited');
      _stopBar(fillId);
      fillEl.style.transition = '';

      if (total === 0) {
        // Idle : pulse lent 3–6%
        _pulseBar(fillEl, fillId, 4.5, 1.5, 0.012);
      } else if (posInCycle === 1) {
        // Début de cycle : pulse excité bas
        const center = total === 1 ? 33 : floor + 8;
        _pulseBar(fillEl, fillId, center, 7, 0.04);
      } else if (posInCycle === 2) {
        // Milieu de cycle : pulse excité haut
        _pulseBar(fillEl, fillId, total === 2 ? 66 : floor + 18, 6, 0.045);
      } else {
        // Palier : spike à 100% puis redescend au floor suivant
        _setBar(fillEl, fillId, 100, floor);
      }

      if (textEl) textEl.textContent = msg;
    });
  }

  // ── FREE badges ───────────────────────────────────────────────────────────
  // Les charms sont parcourus dans l'ORDRE DE SÉLECTION (le plus ancien en premier).
  // Dans chaque groupe de 4 : positions 0 et 1 = payants, 2 et 3 = FREE.
  // Ainsi le badge apparaît dès le 3e charm et ne bouge plus.
  function buildFreeMap() {
    if (TEST_B) return new Map();
    const entries = [...state.charms.entries()]
      .map(([id, data]) => ({ id, ...data }))
      .sort((a, b) => a.selectionOrder - b.selectionOrder);

    const freeMap = new Map();
    let cursor = 0;
    for (const entry of entries) {
      let freeForEntry = 0;
      for (let q = 0; q < entry.qty; q++) {
        if (cursor % 3 >= 1) freeForEntry++;
        cursor++;
      }
      if (freeForEntry > 0) freeMap.set(entry.id, freeForEntry);
    }
    return freeMap;
  }

  function updateCharmFreeBadges(total, freeCount) {
    if (freeCount === 0) {
      $$('.cb-free-badge').forEach(b => { b.hidden = true; });
      $$('.cb-card--charm').forEach(c => c.classList.remove('cb-card--has-free'));
      return;
    }
    const freeMap = buildFreeMap();
    $$('.cb-card--charm').forEach(card => {
      const badge = $('.cb-free-badge', card);
      const isFree = freeMap.has(card.dataset.variantId);
      if (badge) badge.hidden = !isFree;
      card.classList.toggle('cb-card--has-free', isFree);
    });
  }

  // ── Summary bloc ──────────────────────────────────────────────────────────
  function updateSummary(total, paid, free) {
    const chainCost = state.chainQty * PRICES.chain;
    const locketCost = [...state.lockets.values()].reduce((s, q) => s + q * PRICES.locket, 0);
    let fullPrice = locketCost + total * PRICES.charm + chainCost;
    let discountedPrice = locketCost + paid * PRICES.charm + chainCost;
    if (TEST_B) {
      let charmsPaid = 0, charmsCompare = 0;
      for (const [id, { qty }] of state.charms.entries()) { charmsPaid += qty * charmPrice(id); charmsCompare += qty * charmCompare(id); }
      fullPrice = locketCost + charmsCompare + chainCost;
      discountedPrice = locketCost + charmsPaid + chainCost;
    }

    const listEl = document.getElementById('cb-summary-list');
    const priceOrigEl = document.getElementById('cb-price-original');
    const priceTotalEl = document.getElementById('cb-price-total');

    const lines = [];

    // Lockets
    for (const [variantId, qty] of state.lockets.entries()) {
      const card = document.querySelector(`.cb-card--locket[data-variant-id="${variantId}"]`);
      const title = card?.dataset.productTitle || 'Locket';
      const label = qty > 1 ? `${title} ×${qty}` : title;
      lines.push({ label, price: fmt$(qty * PRICES.locket) });
    }

    // Chaîne incluse (gratuite, non facturée, jamais dans le panier)
    const goldThickInc = totalGoldThickLocketsSelected();
    const teardropInc = totalTeardropLocketsSelected();
    const silverInc = totalSilverLocketsSelected();
    if (goldThickInc > 0) {
      lines.push({ label: `Gold thick chain ×${goldThickInc} (included)`, price: 'FREE' });
    }
    if (teardropInc > 0) {
      lines.push({ label: `Gold thin chain ×${teardropInc} (included)`, price: 'FREE' });
    }
    if (silverInc > 0) {
      lines.push({ label: `Silver thick chain ×${silverInc} (included)`, price: 'FREE' });
    }

    // Chain extra (payante)
    if (state.chainQty > 0) {
      const label = state.chainQty > 1 ? `24" Gold Thin Chain ×${state.chainQty}` : '24" Gold Thin Chain';
      lines.push({ label, price: fmt$(state.chainQty * PRICES.chain) });
    }

    // Charms — même logique de free que les badges
    const freeMap = buildFreeMap();

    for (const [variantId, { qty }] of state.charms.entries()) {
      const card = document.querySelector(`.cb-card--charm[data-variant-id="${variantId}"]`);
      const title = card?.dataset.productTitle || 'Charm';
      const freeQty = freeMap.get(variantId) || 0;
      const paidQty = qty - freeQty;
      const label = qty > 1 ? `${title} ×${qty}` : title;
      const priceStr = freeQty > 0
        ? paidQty > 0 ? `${fmt$(paidQty * PRICES.charm)} + ${freeQty} FREE` : 'FREE'
        : fmt$(qty * charmPrice(variantId));
      lines.push({ label, price: priceStr });
    }

    const summaryDetails = document.getElementById('cb-summary-details');
    if (lines.length === 0) {
      if (summaryDetails) summaryDetails.hidden = true;
      return;
    }
    if (summaryDetails) summaryDetails.hidden = false;
    {
      listEl.innerHTML = lines.map(l =>
        `<li class="cb-summary-list__item">
          <span class="cb-summary-list__item-name">${l.label}</span>
          <span class="cb-summary-list__item-price">${l.price}</span>
        </li>`
      ).join('');
    }

    if (free > 0 || (TEST_B && total > 0)) {
      priceOrigEl.textContent = fmt$(fullPrice);
      priceOrigEl.hidden = false;
    } else {
      priceOrigEl.hidden = true;
    }
    priceTotalEl.textContent = fmt$(discountedPrice);
  }

  function updateCartButtonState(total) {
    const btn = document.getElementById('cb-add-to-cart');
    const hint = document.getElementById('cb-btn-hint');
    const hasLocket = totalLocketsSelected() > 0;
    const hasCharms = total >= MIN_CHARMS;
    btn.disabled = !(hasLocket && hasCharms);

    if (!hasLocket && !hasCharms) {
      hint.textContent = 'Please select a locket and at least 1 charm';
      hint.classList.remove('cb-btn-cart__hint--promo');
    } else if (!hasLocket) {
      hint.textContent = 'Please select a locket to continue';
      hint.classList.remove('cb-btn-cart__hint--promo');
    } else if (!hasCharms) {
      hint.textContent = 'Please add at least 1 charm to continue';
      hint.classList.remove('cb-btn-cart__hint--promo');
    } else {
      // Sélection complète → message marketing
      hint.textContent = '🎁 Free gift box included with every locket';
      hint.classList.add('cb-btn-cart__hint--promo');
    }
  }

  function updateUI() {
    syncChainToLockets();
    renderIncludedChain();
    const total = totalCharmsSelected();
    const { free, paid } = computeBogo(total);
    updateBogoProgress(total);
    updateCharmFreeBadges(total, free);
    updateSummary(total, paid, free);
    updateCartButtonState(total);
  }

  // Re-plafonne la chaîne au nombre de lockets et gère l'état des boutons
  function syncChainToLockets() {
    const card = document.querySelector('.cb-card--chain');
    if (!card) return;
    const max = totalGoldLocketsSelected();
    // Si plus aucun locket, on remet la chaîne à 0
    const cap = Math.max(max, 0);
    if (state.chainQty > cap) {
      state.chainQty = cap;
      state.chainVariantId = cap > 0 ? card.dataset.variantId : null;
      const qtyEl = $('.cb-qty__value', card);
      if (qtyEl) qtyEl.textContent = cap;
      card.classList.toggle('cb-card--selected', cap > 0);
      $('.cb-qty__btn--minus', card).disabled = cap === 0;
    }
    // Bouton + désactivé quand on atteint le nombre de lockets (ou 0 locket)
    const plus = $('.cb-qty__btn--plus', card);
    if (plus) plus.disabled = max === 0 || state.chainQty >= max;
  }

  function showError(id) { const el = document.getElementById(id); if (el) el.hidden = false; }
  function hideError(id) { const el = document.getElementById(id); if (el) el.hidden = true; }

  // ── Add to cart ───────────────────────────────────────────────────────────
  function initAddToCart() {
    const btn = document.getElementById('cb-add-to-cart');
    const btnText = $('.cb-btn-cart__text', btn);
    const btnLoading = $('.cb-btn-cart__loading', btn);

    btn.addEventListener('click', async () => {
      let valid = true;

      if (totalLocketsSelected() === 0) {
        showError('cb-locket-error');
        document.getElementById('cb-locket-section').scrollIntoView({ behavior: 'smooth', block: 'start' });
        valid = false;
      }
      if (totalCharmsSelected() < MIN_CHARMS) {
        showError('cb-charms-error');
        if (valid) document.getElementById('cb-charms-section').scrollIntoView({ behavior: 'smooth', block: 'start' });
        valid = false;
      }
      if (!valid) return;

      // Shopify affiche le dernier ajouté en haut → on envoie charms en premier, locket en dernier
      const items = [];
      for (const [variantId, { qty }] of state.charms.entries()) {
        if (qty > 0) items.push({ id: parseInt(variantId), quantity: qty });
      }
      if (state.chainVariantId && state.chainQty > 0) {
        items.push({ id: parseInt(state.chainVariantId), quantity: state.chainQty });
      }
      for (const [variantId, qty] of state.lockets.entries()) {
        items.push({ id: parseInt(variantId), quantity: qty });
      }

      btn.disabled = true;
      btnText.hidden = true;
      btnLoading.hidden = false;

      // Filtre les IDs invalides avant d'envoyer
      const validItems = items.filter(item => item.id && !isNaN(item.id) && item.quantity > 0);
      if (validItems.length === 0) {
        btn.disabled = false;
        btnText.hidden = false;
        btnLoading.hidden = true;
        return;
      }

      // Horizon 4.2+ : le tiroir panier écoute l'événement standard CartLinesUpdateEvent
      // (@shopify/events), plus l'ancien 'cart:update'. On reproduit product-form.js.
      let deferred = null;
      let CartLinesUpdateEvent = null;
      try {
        ({ CartLinesUpdateEvent } = await import('@shopify/events'));
        deferred = CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: validItems.map(i => ({ merchandiseId: String(i.id), quantity: i.quantity })),
          promise: deferred.promise,
        }));
      } catch (evErr) {
        console.warn('[charm-builder] événement panier indisponible', evErr);
      }

      try {
        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map(el => el.dataset.sectionId).filter(Boolean);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: validItems, sections: sectionIds.join(',') }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Cart error');
        }

        // Reset bouton
        btn.disabled = false;
        btnText.hidden = false;
        btnLoading.hidden = true;

        const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
        if (deferred && CartLinesUpdateEvent) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'product-form-component',
              sourceId: 'charm-builder',
              itemCount: validItems.reduce((n, i) => n + i.quantity, 0),
              sections: data.sections,
              didError: false,
            },
          });
        }
      } catch (e) {
        if (deferred) deferred.reject(e);
        btn.disabled = false;
        btnText.hidden = false;
        btnLoading.hidden = true;
        alert(e.message || 'Something went wrong. Please try again.');
      }
    });
  }

  // ── Sort charms + titre unique Birthstones & Letters ─────────────────────
  function sortCharms() {
    const MONTHS = ['january','february','march','april','may','june',
                    'july','august','september','october','november','december'];

    // Ordre exact des charms classiques par titre Shopify
    const CHARM_EXACT_ORDER = [
      'Love','Mama','Mom','Mum',
      'Boy (Limited stock)','Girl (Limited stock)',
      'Home Sweet Home','Tree of life',
      'Dog','Cat','Dog Paw (Limited stock)','Cat Paw',
      'Heart','Cloud','Moon (Limited stock)','Butterfly',
      'Cross (Limited stock)','Elephant','Mistletoe','Dove',
      'Sun','Ladybug','Four-leaf clover','Heart moon',
      'Palm Tree','Cherry','Champagne','Star',
      'Pineapple','Dolphin','Eye','Horseshoe',
      'Rose','Slipper','Iris','Dragonfly',
      'Fawn','Gecko','Hummingbird','Clover',
    ];

    function getCharmOrderIndex(title) {
      const idx = CHARM_EXACT_ORDER.indexOf(title);
      return idx === -1 ? CHARM_EXACT_ORDER.length : idx;
    }

    function getSortKey(title) {
      const t = title.toLowerCase().trim();
      if (/^[a-z]$/.test(t)) return `c_${t}`;
      for (let i = 0; i < MONTHS.length; i++) {
        if (t.includes(MONTHS[i])) return `b_${String(i + 1).padStart(2, '0')}`;
      }
      return `a_${String(getCharmOrderIndex(title)).padStart(3, '0')}_${t}`;
    }

    const grid = document.querySelector('.cb-section--charms .cb-grid');
    if (!grid) return;

    const sorted = [...grid.querySelectorAll('.cb-card--charm')]
      .sort((a, b) =>
        getSortKey(a.dataset.productTitle || '').localeCompare(
          getSortKey(b.dataset.productTitle || '')
        )
      );

    grid.querySelectorAll('.cb-charm-category-title').forEach(el => el.remove());

    let currentCategory = null;
    sorted.forEach(card => {
      const key = getSortKey(card.dataset.productTitle || '');
      const cat = key[0]; // 'a', 'b' ou 'c'
      if (cat !== currentCategory) {
        currentCategory = cat;
        // Un seul titre pour 'b' (couvre aussi les lettres 'c')
        if (cat === 'b') {
          const heading = document.createElement('div');
          heading.className = 'cb-charm-category-title';
          heading.textContent = 'Birthstones & Letters (5×5mm / 0.2")';
          grid.appendChild(heading);
        }
      }
      grid.appendChild(card);
    });
  }

  // Scroll capture supprimé — comportement natif CSS géré dans charm-builder.css

  function init() {
    initGallery();
    initLockets();
    initChain();
    sortCharms();
    initCharms();
    initAddToCart();
    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
